import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5da476a5")
const _hoisted_1 = {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label text-gray-600 fs-5" }, "New UI", -1)
const _hoisted_6 = {
  id: "kt_aside_toggle",
  class: "btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1 rotate-180" }
const _hoisted_8 = { class: "aside-menu flex-column-fluid" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_aside",
    class: _normalizeClass(["aside aside-hoverable", [
        _ctx.asideTheme === 'light' && 'aside-light',
        _ctx.asideTheme === 'dark' && 'aside-dark',
    ]]),
    "data-kt-drawer": "true",
    "data-kt-aside-minimize": "off",
    "data-kt-drawer-name": "aside",
    "data-kt-drawer-activate": "{default: true, lg: false}",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
    "data-kt-drawer-direction": "start",
    "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.asideTheme === 'dark')
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            alt: "Logo",
            src: _ctx.originUrl + _ctx.darkLogo,
            class: "h-40px logo"
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_ctx.asideTheme === 'light')
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            alt: "Logo",
            src: _ctx.originUrl + _ctx.lightLogo,
            class: "h-40px logo"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input w-40px h-25px",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAppVersion())),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.appVersion = $event)),
          type: "checkbox",
          value: "1",
          name: "mode"
        }, null, 544), [
          [_vModelCheckbox, _ctx.appVersion]
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_inline_svg, {
            src: _ctx.originUrl + '/media/icons/duotune/arrows/arr079.svg'
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_KTMenu)
    ])
  ], 2))
}